import { AxiosResponse } from "axios";
import PagedResponse from "../models/PagedResponse";
import Api from "./Api";

export type BusinessUnitResponse = TestRequestRaw.Schemas.CrmBusinessUnitResponse;
export type MarketSegmentResponse = TestRequestRaw.Schemas.CrmMarketSegmentResponse;
export type ApplicationFieldResponse = TestRequestRaw.Schemas.CrmApplicationFieldResponse;

class ContextApi {
  constructor(private api: Api) {}

  public loadBusinessUnits(): Promise<BusinessUnitResponse[]> {
    return this.api
      .get("/test-request/v2/applications/business-units")
      .then((response: AxiosResponse<PagedResponse<BusinessUnitResponse>>) => response.data.data);
  }

  public loadMarketSegments(businessUnit?: string): Promise<MarketSegmentResponse[]> {
    if (!businessUnit) {
      return Promise.resolve([]);
    }
    return this.api
      .get(`/test-request/v2/applications/market-segments?businessUnit=${encodeURIComponent(businessUnit)}`)
      .then((response: AxiosResponse<PagedResponse<MarketSegmentResponse>>) => response.data.data);
  }

  public loadApplicationFields(marketSegment?: string): Promise<ApplicationFieldResponse[]> {
    if (!marketSegment) {
      return Promise.resolve([]);
    }
    return this.api
      .get(`/test-request/v2/applications/application-fields?marketSegment=${encodeURIComponent(marketSegment)}`)
      .then((response: AxiosResponse<PagedResponse<ApplicationFieldResponse>>) => response.data.data);
  }
}

export default ContextApi;
